import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { IUserSocial, IUserSocialMedia } from "@/types/user.types";
import selectColorSocialMedia from "@/components/common/selectColorSocialMedia";
import svgArr from "@/components/common/socialMediaSvg";

export const useUSerSocialMedia = create<IUserSocialMedia>((set) => ({
  data: {
    dynamic: "1",
    name: "",
    sharing: "1",
    design_colors_primary: selectColorSocialMedia[0].color,
    design_colors_button: selectColorSocialMedia[0].buttonColor,
    template: "",
    template_path: "",
    template_name: "",
    template_type: "",
    upload_svg: {
      key: "one",
      icon: svgArr[0].icon,
    },
    headline: "",
    about_us: "",
    welcome_screen: "",
    welcome_path: "",
    svgColor: "#2E576F",
    showUploadOwn: false,
    socialItems: [
      {
        id: 0,
        icon: `/social-items/website.svg`,
        type: "website",
        text: "Check our website",
        value: "www.mywebsite.com",
      },
      {
        id: 1,
        icon: `/social-items/youtube.svg`,
        type: "youtube",
        text: "Subscribe our channel",
        value: "www.youtube.com/channel",
      },
      {
        id: 2,
        icon: `/social-items/instagram.svg`,
        type: "instagram",
        text: "Follow us",
        value: "www.instagram.com/username",
      },
    ],
  },
  socialTypes: [
    {
      icon: `/social-items/website.svg`,
      text: "Check our website",
      active: true,
      type: "website",
    },
    {
      icon: `/social-items/facebook.svg`,
      text: "Like our page",
      active: false,
      type: "facebook",
    },
    {
      icon: `/social-items/twitter.svg`,
      text: "Follow us",
      active: false,
      type: "twitter",
    },
    {
      icon: `/social-items/instagram.svg`,
      text: "Follow us",
      active: true,
      type: "instagram",
    },
    {
      icon: `/social-items/linkedin.svg`,
      text: "Join our network",
      active: false,
      type: "linkedin",
    },
    {
      icon: `/social-items/youtube.svg`,
      text: "Subscribe our channel",
      active: true,
      type: "youtube",
    },
    {
      icon: `/social-items/wp.svg`,
      text: "Contact us",
      active: false,
      type: "whatsapp",
    },
    {
      icon: `/social-items/tg.svg`,
      text: "Send us a message",
      active: false,
      type: "telegram",
    },
    {
      icon: `/social-items/snap.svg`,
      text: "Check out our stories",
      active: false,
      type: "snapchat",
    },
    {
      icon: `/social-items/tiktok.svg`,
      text: "Follow us",
      active: false,
      type: "tiktok",
    },
  ],
  color: [
    {
      color: "#2E576F",
    },
    {
      color: "#A42114",
    },
    {
      color: "#DB7139",
    },
    {
      color: "#7966D2",
    },
    {
      color: "#133276",
    },
    {
      color: "#A3274E",
    },
  ],
  config: {},
  setConfig: (val) =>
    set((state) => ({
      ...state,
      config: { ...state.config, val },
    })),
  setSvgColor: (val) => {
    set((state) => {
      return {
        ...state,
        data: {
          ...state.data,
          svgColor: val,
        },
      };
    });
  },
  setSvgIcon: (val) => {
    set((state) => {
      return {
        ...state,
        data: {
          ...state.data,
          upload_svg: {
            ...state.data.upload_svg,
            icon: val,
          },
        },
      };
    });
  },
  setUserSocialMedia: (val, type, from) => {
    set((state) => {
      if (type === "social") {
        return {
          ...state,
          data: {
            ...state.data,
            [from!]: {
              ...(state.data[from!] as object),
              ...val,
            },
          },
        };
      }

      return { ...state, data: { ...state.data, ...val } };
    });
  },
  setDeleteSocialItem: (index, qrShowId) => {
    set((state) => {
      const afterDeleted = state.data.socialItems.filter((e, i) => {
        if (qrShowId) {
          e.id = e.id > 0 ? e.id - 1 : e.id;
        }

        return i !== index;
      });

      return {
        ...state,
        data: {
          ...state.data,
          socialItems: afterDeleted,
        },
      };
    });
  },
  setSocialItems: (val, type, index, action) => {
    set((state) => {
      if (type === "add") {
        return {
          ...state,
          data: {
            ...state.data,
            socialItems: [...state.data.socialItems, val],
          },
        };
      } else if (type === "update_value" && action) {
        (state.data.socialItems[index] as any)[action] = val; // Using `any` to bypass type checking
        return { ...state };
      } else if (type === "error") {
        state.data.socialItems[index].error = val;
        return { ...state };
      } else {
        return { ...state, socialItems: val };
      }
    });
  },
  setReorderSocial: (val) => {
    set((state) => {
      return {
        ...state,
        data: {
          ...state.data,
          socialItems: val,
        },
      };
    });
  },
  setSocialTypes: (val) => {
    set((state) => {
      const newSocialTypesState = state.socialTypes.map((obj) => {
        if (
          obj.type.toUpperCase().replace(/\s+/g, "") === val.type.toUpperCase().replace(/\s+/g, "")
        ) {
          return { ...obj, active: val.active };
        }

        return obj;
      });

      return { ...state, socialTypes: newSocialTypesState };
    });
  },
  setDeleteSocialTypes: (val) => {
    set((state) => {
      const deleted = state.data.socialItems.filter(
        (e) =>
          e.type.toUpperCase().replace(/\s+/g, "") !== val.type.toUpperCase().replace(/\s+/g, ""),
      );

      return {
        ...state,
        data: {
          ...state.data,
          socialItems: deleted,
        },
      };
    });
  },
  setDeleteUserSocialMedia: (val) => {
    set((state) => {
      delete state.data[val];

      return { ...state };
    });
  },
  destroySocialMedia: () => {
    set(() => {
      return {
        data: {
          dynamic: "1",
          name: "",
          sharing: "1",
          design_colors_primary: selectColorSocialMedia[0].color,
          design_colors_button: selectColorSocialMedia[0].buttonColor,
          template: "",
          template_path: "",
          template_name: "",
          template_type: "",
          upload_svg: {
            key: "one",
            icon: svgArr[0].icon,
          },
          headline: "",
          about_us: "",
          welcome_screen: "",
          welcome_path: "",
          svgColor: "#2E576F",
          showUploadOwn: false,
          socialItems: [
            {
              id: 0,
              icon: `/social-items/website.svg`,
              type: "website",
              text: "Check our website",
              value: "www.mywebsite.com",
            },
            {
              id: 1,
              icon: `/social-items/youtube.svg`,
              type: "youtube",
              text: "Subscribe our channel",
              value: "www.youtube.com/channel",
            },
            {
              id: 2,
              icon: `/social-items/instagram.svg`,
              type: "instagram",
              text: "Follow us",
              value: "www.instagram.com/username",
            },
          ],
        },
        socialTypes: [
          {
            icon: `/social-items/website.svg`,
            text: "Check our website",
            active: true,
            type: "website",
          },
          {
            icon: `/social-items/facebook.svg`,
            text: "Like our page",
            active: false,
            type: "facebook",
          },
          {
            icon: `/social-items/twitter.svg`,
            text: "Follow us",
            active: false,
            type: "twitter",
          },
          {
            icon: `/social-items/instagram.svg`,
            text: "Follow us",
            active: true,
            type: "instagram",
          },
          {
            icon: `/social-items/linkedin.svg`,
            text: "Join our network",
            active: false,
            type: "linkedin",
          },
          {
            icon: `/social-items/youtube.svg`,
            text: "Subscribe our channel",
            active: true,
            type: "youtube",
          },
          {
            icon: `/social-items/wp.svg`,
            text: "Contact us",
            active: false,
            type: "whatsapp",
          },
          {
            icon: `/social-items/tg.svg`,
            text: "Send us a message",
            active: false,
            type: "telegram",
          },
          {
            icon: `/social-items/snap.svg`,
            text: "Check out our stories",
            active: false,
            type: "snapchat",
          },
          {
            icon: `/social-items/tiktok.svg`,
            text: "Follow us",
            active: false,
            type: "tiktok",
          },
        ],
        color: [
          {
            color: "#2E576F",
          },
          {
            color: "#A42114",
          },
          {
            color: "#DB7139",
          },
          {
            color: "#7966D2",
          },
          {
            color: "#133276",
          },
          {
            color: "#A3274E",
          },
        ],
      };
    });
  },
  editSocialItems: (val) => {
    set((state) => {
      return { ...state, socialItems: val };
    });
  },
}));

export const useUserSocial = create(
  persist<IUserSocial>(
    (set) => ({
      dynamic: "1",
      name: "",
      url: "",
      type: "",
      isDownload: false,
      config: {},
      setParams: (val) => {
        set((state) => {
          return { ...state, ...val };
        });
      },
      setConfig: (val) => {
        set((state) => {
          return { ...state, config: { ...state.config, ...val } };
        });
      },
      destroyUserSocial: () => {
        set({
          dynamic: "1",
          name: "",
          url: "",
          type: "",
          isDownload: false,
          config: {},
        });
      },
    }),
    {
      name: "userSocial",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
